const API_KEY = 'UkDHjJ0j3Ikap8QAwXRtUOxki4j4Oh4dzH2EXENYRNY';
const API_BASE = 'https://api.billuzo.com/api';

export async function apiCall(endpoint, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const url = new URL(`${API_BASE}${endpoint}`);
  if (method === 'GET') {
    // Force fresh reads so the dashboard never reuses stale cached snapshots.
    url.searchParams.set('_ts', String(Date.now()));
  }
  const headers = {
    'Content-Type': 'application/json',
    'X-API-Key': API_KEY,
    ...options.headers,
  };
  try {
    const response = await fetch(url.toString(), { ...options, headers, cache: 'no-store' });
    if (!response.ok) throw new Error(`API error: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error(`API call failed: ${endpoint}`, error);
    throw error;
  }
}

export const API = {
  getStatus:     () => apiCall('/status'),
  getSectors:    () => apiCall('/sectors'),
  getTrades:     (params = '') => apiCall(`/trades/recent${params}`),
  getPnLHistory: () => apiCall('/pnl/history'),
  getAllocator:  () => apiCall('/allocator'),
  getEfectividad: () => apiCall('/efectividad'),
};
